
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('captionMain.vrun.component', () => import('./CaptionMain.vue'))
